import { RemoteDeleteCompletedEvaluation } from 'data/usecases';
import { DeleteCompletedEvaluationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCompletedEvaluations } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteDeleteCompletedEvaluation =
  (): DeleteCompletedEvaluationUseCaseInterface =>
    new RemoteDeleteCompletedEvaluation(
      makeApiUrlCompletedEvaluations(),
      makeAxiosHttpClient(),
    );
